import { AbstractPmsApiService } from './abstract.service';
import { SupportRequest } from '../models/support-request.model';

/**
 * @class SupportRequest
 * @abstract
 * @extends {AbstractPmsApiService<SupportRequest>}
 */
export class SupportRequestPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/contact-us';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {SupportRequest}
     * @protected
     */
    newModel(attributes, ...params) {

        return new SupportRequest(attributes);
    }

    /**
     * @param {SupportRequest|Model} supportRequest
     * @returns {Promise.<Boolean>}
     */
    sendRequest(supportRequest) {

        const url = this.url();

        return this.http
            .post(url, supportRequest.toObject(), {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/support-request.service.js